import { Center, Spinner, Stack } from '@chakra-ui/react'
import React from 'react'
import {
  DashboardHeader,
  NavigationActions,
  ProfileIncompleteAlert,
  PurpleBubbleDisplay,
  DashboardGrid,
} from './components'
import { useDashboardData, useReportingControls } from './hooks'

const HomePage: React.FC = () => {
  const {
    dayOfMonthLimit,
    pastDeadline,
    isReady,
    setSelectedMonth,
    effectiveCurrentMonth,
    monthMoment,
    month,
    changeToMoment,
  } = useReportingControls()

  const { user, report, stagesCount, purpleBubbleContent, isLoading } =
    useDashboardData(month, isReady)

  // Show the final dayOfMonthLimit value once it's ready
  if (isReady) {
    console.log('dayOfMonthLimit:', dayOfMonthLimit)
  }

  const handleMonthChange = () => {
    setSelectedMonth(!effectiveCurrentMonth)
  }

  return (
    <Stack spacing={2}>
      {isLoading ? (
        <Center height='50vh'>
          <Spinner
            thickness='4px'
            speed='0.65s'
            emptyColor='gray.200'
            color='purple.500'
            size='xl'
          />
        </Center>
      ) : (
        <>
          <DashboardHeader
            user={user}
            monthMoment={monthMoment}
            changeToMoment={changeToMoment}
            pastDeadline={pastDeadline}
            onMonthChange={handleMonthChange}
          />
          {!user ? null : user.profile ? (
            <>
              <PurpleBubbleDisplay purpleBubbleContent={purpleBubbleContent} />
              <NavigationActions month={month} />
            </>
          ) : (
            <ProfileIncompleteAlert />
          )}
          <DashboardGrid
            month={month}
            report={report}
            stagesCount={stagesCount}
          />
        </>
      )}
    </Stack>
  )
}

export default HomePage
